module.exports = __webpack_public_path__ + "Flag-234.38b0ad495b9dc0f6c43e529d3059a90a.svg";